import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from 'src/app/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { LimitDialogComponent } from './limit-dialog.component';



@NgModule({
  declarations: [
    LimitDialogComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    SharedModule
  ],
  exports: [
    LimitDialogComponent
  ],
  entryComponents: [
    LimitDialogComponent
  ]
})
export class LimitDialogModule { }
